import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 448 512"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M224 32c-88.4 0-160 71.6-160 160v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16C32 86 118 0 224 0s192 86 192 192v16c0 61.9-50.1 112-112 112h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32h32c44.2 0 80-35.8 80-80v-16c0-88.4-71.6-160-160-160m0 32c70.7 0 128 57.3 128 128 0 13.9-2.2 27.3-6.3 39.8-8.3 14.5-23.9 24.2-41.7 24.2h-8.6c-2.7-4.7-6.1-9.1-9.9-12.9 11.6-13.9 18.5-31.7 18.5-51.1 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 19.4 6.9 37.2 18.4 51.1C151 254.6 144 270.5 144 288c0 1.4 0 2.7.1 4C114.8 268.6 96 232.5 96 192c0-70.7 57.3-128 128-128m-16 288h105.6c74.2 0 134.4 60.2 134.4 134.4 0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4 0 412.2 60.2 352 134.4 352H208m105.6 48H134.4c-40 0-73.6 27.1-83.5 64h346.2c-9.9-36.9-43.5-64-83.5-64" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }